/**
 * MQTT helper utilities.
 *
 * Contains topic name generation and other MQTT-specific helpers.
 * eventTopicName() generates MQTT topic names for user event channels.
 */

import { getUserId } from 'helpers/cookies';
const sha1 = require('js-sha1');

/**
 * Generate the MQTT topic name for the current user's event channel.
 * Format: user_event/<sha1("user.<user_id>")>
 *
 * @returns {string} MQTT topic name
 */
export const eventTopicName = () => {
  return `user_event/${sha1(`user.${getUserId()}`)}`;
};
